import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios, getPreviewDynamicData, isDisabledSfIntegration } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import {
  doProcessRules,
  getCalendarFileContent,
  getElementFromPath,
  getParams,
  getState,
  getValueByField,
  toPlainValue,
  updateOldValue,
} from '../../lib/processPortalRules'
import { fromJS, List, Map } from 'immutable'
import { processViewItemSelect } from './processViewItemSelect'
import { getElementDataRoot } from '../../constants/getElementDataRoot'
import { CURRENT_PROJECT, HISTORY_ENTRY_COUNT, HISTORY_PREV } from '../../constants/HISTORY_ENTRY_COUNT'
import { ftSetLocalStorage, toJS } from '../../lib/common'
import { processSFItemCancel } from './processCondCache'
import { processChangeUILoading } from './processChangeUILoading'
import { SURVEY_TYPE } from '../../constants/features'
import { getPageUID } from '../../lib/getValueByType'
import { getMappingCount } from '../../constants/getMappingCount'
import { getFormDateFormat } from '../../lib/format.js'
import moment from 'moment'
import { ftDeleteOfflineValue, ftSetOfflineValue } from '../../lib/offline-storage'
import { compressToUTF16 } from 'lz-string'
import { collectAutoPDFState } from './processDocGen'
import { applyPushNotificationToken } from '../utils'

export const axios = getAxios()

let rulesStatusCache = []
let applyTime = null
export const setCondRulesStatus = (path, status, isChanged) => (dispatch) => {
  clearTimeout(applyTime)
  rulesStatusCache.push({
    path,
    status,
    isChanged,
  })
  applyTime = setTimeout(() => {
    dispatch({
      type: actionTypes.COND_RULES_SET_STATUS_BATCH,
      payload: {
        rules: rulesStatusCache,
      },
    })
    rulesStatusCache = []
  }, 50)
}

export const setSfFormMode = () => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['ProjectType'], 'sfForm'),
    },
  })

export const setProjectWizard = (value) => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['project', 'Settings', 'private', 'projectWizard'], value),
    },
  })

export const setStore = (state) => (dispatch) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
export const clearPowerTableColState = (uid, pageUID) => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState()
        .setIn(['state', pageUID, uid], Map())
        .setIn(['state', pageUID, `${uid}-totalRows`], '')
        .setIn(['state', pageUID, `${uid}-selectedItems`], ''),
    },
  })

export const applyPowerTableColWidths = (uid, PageID, columnWidths) => (dispatch, getState) => {
  const state = getState()
  let ret = state
    .setIn(['isProjectChanged'], true)
    .setIn(['isPageChanged'], true)
    .setIn(
      HISTORY_PREV,
      state.getIn(HISTORY_PREV, List()).size >= HISTORY_ENTRY_COUNT
        ? state.getIn(HISTORY_PREV, List()).shift().push(CURRENT_PROJECT(state))
        : state.getIn(HISTORY_PREV, List()).push(CURRENT_PROJECT(state))
    )
  const layoutMode = state.get('layoutMode', 'lg')

  if (!_.isEmpty(columnWidths)) {
    ret = ret.setIn(
      [...getElementDataRoot(PageID), 'elements', uid, 'props', layoutMode, 'columnWidths'],
      fromJS(
        _.merge(
          {},
          ret
            .getIn([...getElementDataRoot(PageID), 'elements', uid, 'props', layoutMode, 'columnWidths'], Map())
            .toJS(),
          columnWidths
        )
      )
    )

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: ret,
      },
    })
  }
}

export const loadSmartVPickList = (target, uid, PageUID) => async (dispatch, getState) => {
  try {
    const { status, data } = await axios.post('/webprojects/loadSmartVPicklist', { target, uid, PageUID })
    if (status === 200 && data.status) {
      let state = getState()
      if (uid) {
        state = state.setIn(['meta', 'SmartV-' + uid], fromJS(data.data))
      } else {
        state = state.setIn(['meta', 'SmartV'], fromJS(data.data))
      }

      return dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    }
  } catch (error) {}
  dispatch({
    type: actionTypes.NOTIFY_ERROR,
    payload: {
      key: uuid(),
      message: `An error occurred while load picklists, try again later.`,
    },
  })
}

export const projectSyncParams = (params) => (dispatch, getState) => {
  let changes = []
  let state = getState()
  if (_.isObject(params)) {
    _.each(params, (value, key) => {
      if (value && typeof value === 'object') {
        try {
          let val1 = JSON.stringify(value)
          let val2 = state.getIn(['params', key])
          if (isImmutable(val2)) {
            val2 = val2.toJS()
          }
          val2 = JSON.stringify(val2)
          if (val1 != val2) {
            changes.push([key])
            state = state.setIn(['params', key], value)
          }
        } catch (err) {}
      } else if (state.getIn(['params', key]) !== value) {
        changes.push([key])
        state = state.setIn(['params', key], value)
      }
    })
  }

  if (changes.length > 0) {
    state = doProcessRules(state, false, [], [], changes, false, false)
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
}

export const setRegFormState = (formState) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().set('ftFormState', fromJS(formState)),
    },
  })
}

export const setConfirmationSwitchPage = (isOpen, pageID, projectID, elemUID) => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.PROJECT_CHANGE_MODAL_STATE,
    payload: {
      modal: 'confirmationChangePage',
      state: {
        pageID,
        projectID,
        elemUID,
        open: isOpen,
      },
    },
  })
}

export const goToPageWithConfirmation =
  (pageID, projectID, elemUID, withoutConfirmation = false, isSave = false) =>
  async (dispatch, getState) => {
    if (isSave) {
      let module = await import('./handleSaveProject')
      await dispatch(module.handleSaveProject(true, true))
    }
    let state = getState()
    let currentPageId = state.get('page')

    if (elemUID && state.getIn(['project', 'ProjectType']) === SURVEY_TYPE) {
      try {
        dispatch(processViewItemSelect(elemUID))
        let parent = state.getIn(['pages', pageID, 'Props', 'Grid', 0])
        if (parent) {
          let tabs = state.getIn(['pages', pageID, 'Props', 'elements', parent, 'props', 'lg', 'tabs'])
          if (tabs) {
            tabs.map((tab) => {
              if (tab && tab.get('children') && tab.get('children').includes(elemUID)) {
                dispatch({
                  type: actionTypes.SET_ELEM_VALUE,
                  payload: {
                    uid: [parent, 'ftListValue'],
                    value: tab.get('id'),
                    type: 'FormField',
                    path: [getPageUID(pageID, state.getIn(['project', 'Pages']))],
                  },
                })
              }
            })
          }
        }
        return false
      } catch (err) {
        console.error(err)
      }
    }

    if (pageID != currentPageId && pageID !== 'project') {
      if (state.getIn(['isPageChanged']) && !withoutConfirmation) {
        dispatch(setConfirmationSwitchPage(true, pageID, projectID, elemUID))
        return false
      } else {
        await dispatch(projectBuilderSelectPage(pageID, projectID))
        dispatch(processViewItemSelect(elemUID))
      }
    } else {
      dispatch(processViewItemSelect(elemUID))
    }
    dispatch(setConfirmationSwitchPage(false))
    const el = document.getElementById(elemUID)
    if (el) {
      el.scrollIntoView({
        block: 'end',
        inline: 'nearest',
      })
    }
  }

export const projectBuilderSelectPage = (pageID, projectID, withoutOpen) => async (dispatch, getState) => {
  try {
    dispatch(processChangeUILoading(true))
    let state = getState()
    if (!pageID) {
      pageID = state.get('page')
    }
    if (!projectID) {
      projectID = state.getIn(['project', '_id'])
    }
    dispatch({
      type: actionTypes.PROJECT_BUILDER_CHANGE_ACTIVE_PAGE,
      payload: {
        page: null,
      },
    })
    if (window.location.href.includes('ftVersion')) {
      dispatch({
        type: actionTypes.PROJECT_BUILDER_SELECT_PAGE,
        payload: {
          page: pageID,
        },
      })
      if (typeof window?.__FT__BUILDER_API__?.changePage === 'function') {
        window.__FT__BUILDER_API__.changePage(pageID, projectID, true)
      }
      dispatch(processChangeUILoading(false))
      return null
    }

    // Check if this page has local unsaved changes (e.g., from undo on different page)
    // If so, skip server fetch to preserve local changes
    const hasLocalChanges = state.getIn(['effectedPages', pageID], false)
    if (hasLocalChanges && state.hasIn(['pages', pageID])) {
      // Page has local changes, just switch to it without fetching from server
      if (!withoutOpen) {
        dispatch({
          type: actionTypes.PROJECT_BUILDER_SELECT_PAGE,
          payload: {
            page: pageID,
          },
        })
      }
      if (typeof window?.__FT__BUILDER_API__?.changePage === 'function') {
        window.__FT__BUILDER_API__.changePage(pageID, projectID, true)
      }
      dispatch(processChangeUILoading(false))
      return null
    }

    dispatch({
      type: actionTypes.PROJECT_PAGE_LOADING_STATUS,
      payload: { status: true },
    })
    const { status, data } = await axios.post(`/webprojects/open/${projectID}/${pageID || ''}`)

    if (status === 200 && data.status) {
      // dispatch(wbChangeLayoutMode('lg'))
      dispatch({
        type: actionTypes.PROJECT_UPDATE_PAGES,
        payload: {
          pages: data?.data?.pages ?? {},
        },
      })
      if (!withoutOpen) {
        dispatch({
          type: actionTypes.PROJECT_BUILDER_SELECT_PAGE,
          payload: {
            page: pageID,
          },
        })
      }
      if (typeof window?.__FT__BUILDER_API__?.changePage === 'function') {
        window.__FT__BUILDER_API__.changePage(pageID, projectID, true)
      }
    } else {
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message:
            data.error === 'Not allow'
              ? `You don't have permission/license. Please contact the resource owner.`
              : `Network error. Please try again later.`,
        },
      })
    }
  } catch (error) {
    console.error('>>>', error)
    dispatch({
      type: actionTypes.NOTIFY_ERROR,
      payload: {
        key: uuid(),
        message: `Network error. Please try again later.`,
      },
    })
  } finally {
    dispatch({
      type: actionTypes.PROJECT_PAGE_LOADING_STATUS,
      payload: { status: false },
    })
    dispatch(processChangeUILoading(false))
  }
}

export const setConfirmationHash = (hash) => (dispatch) =>
  dispatch({ type: actionTypes.SET_CONFIRMATION_HASH, payload: { hash } })

export const setSFSmartHash = (hash) => (dispatch) =>
  dispatch({ type: actionTypes.SET_SF_SMART_HASH, payload: { hash } })

const getViewWidgetUIDList = (children) =>
  _.reduce(
    children,
    (ret, child) => {
      if (child.type === 'Widget') {
        return [...ret, [child.uid, child.ref]]
      } else {
        return [...ret, ...getViewWidgetUIDList(child.children)]
      }
    },
    []
  )

export const setPortalData = (portalData) => (dispatch) =>
  dispatch({
    type: actionTypes.PORTAL_SET_DATA,
    payload: {
      portalData,
    },
  })

export const setWidgetData = (data) => (dispatch) =>
  dispatch({
    type: actionTypes.WIDGET_BUILDER_SET_DATA,
    payload: { data },
  })

export const updateLibWidgetData = (uid, data) => (dispatch) =>
  dispatch({
    type: actionTypes.PORTAL_UPDATE_LIB_WIDGET,
    payload: {
      uid,
      data,
    },
  })

export const updateParams = (path, params) => (dispatch) =>
  dispatch({
    type: actionTypes.WIDGET_UPDATE_PARAMS,
    payload: { path, params },
  })

export const portalToggleNavBar = () => (dispatch) => dispatch({ type: actionTypes.PORTAL_TOGGLE_NAVBAR })

export const applyTheme = (theme) => (dispatch) =>
  dispatch({
    type: actionTypes.APPLY_THEME,
    payload: {
      theme,
    },
  })

export const widgetsViewItemResizeParent = (pageID, parent, value) => (dispatch) =>
  dispatch({
    type: actionTypes.WIDGET_VIEW_ITEM_RESIZE_PARENT,
    payload: {
      pageID,
      parent,
      value,
    },
  })

export const widgetsChangeMode = (mode) => (dispatch) =>
  dispatch({
    type: actionTypes.WIDGET_VIEW_MODE,
    payload: { mode },
  })

export const setDefaultTheme = (theme) => (dispatch) =>
  dispatch({
    type: actionTypes.SET_DEFAULT_THEME,
    payload: { theme },
  })

export const closePermissionError = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLOSE_PERMISSION_ERROR,
  })
}

export const setProjectLastID = (id) => (dispatch) => {
  dispatch({ type: actionTypes.PROJECT_LAST_ID, payload: { id } })
}

export const setPermissionError = (error) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PERMISSION_ERROR,
    payload: { error },
  })
}
export const portalSetDefaultPage = (page) => (dispatch) =>
  dispatch({
    type: actionTypes.PORTAL_SET_DEFAULT_PAGE,
    payload: {
      page,
    },
  })

export const portalReorderPage =
  ({ uid, source, destination }) =>
  (dispatch) =>
    dispatch({
      type: actionTypes.PORTAL_REORDER_PAGE,
      payload: {
        uid,
        source,
        destination,
      },
    })

export const clearPortalChanged = () => (dispatch) => dispatch({ type: actionTypes.CLEAR_PORTAL_CHANGED })

export const notifyMessage = (msg, type = 'error') => ({
  type: actionTypes.ENQUEUE_SNACKBAR,
  payload: {
    notification: {
      message: msg,
      type,
    },
  },
})

export const closeNotifyModal = () => (dispatch) => dispatch({ type: actionTypes.CLOSE_LOADING_WINDOW })

export const setWidgetsPreviewData = (widgets) => (dispatch) =>
  dispatch({ type: actionTypes.SET_WIDGETS_DATA, payload: { widgets } })
export const setWidgetPreviewData = (widget, layoutMode) => (dispatch) =>
  dispatch({ type: actionTypes.SET_WIDGET_PREVIEW_DATA, payload: { widget, layoutMode } })
export const setWidgetPreviewMappedData = (data) => (dispatch) =>
  dispatch({ type: actionTypes.SET_WIDGET_PREVIEW_MAPPED_DATA, payload: { data } })

const processChildElems = (children, path, widgets) =>
  _.reduce(
    children,
    (ret, child) => {
      if (child.type === 'Widget') {
        return [
          ...ret,
          {
            widget: _.get(widgets, child.ref),
            path: [...path, child.uid],
          },
          ...processChildWidgets(_.get(widgets, child.ref, {}), widgets, [...path, child.uid]),
        ]
      } else {
        return [...ret, ...processChildElems(child.children, path, widgets)]
      }
    },
    []
  )

export const processChildWidgets = (widget, widgets, path) => [
  ...(_.get(widget, 'Props.sfMapping')
    ? [
        {
          widget: widget,
          path: path,
        },
      ]
    : []),
  ...processChildElems(_.get(widget, 'Props.Grid.children', []), path, widgets),
]

export const setStatusIsAllowDebug = (status) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_IS_ALLOW_DEBUG_MODE,
    payload: {
      status: status,
    },
  })
}

export const unshiftQueryItem = () => (dispatch) =>
  dispatch({
    type: actionTypes.QUERY_UNSHIFT,
  })
export const processWidgetCustomSFPushItem = async (state, sfPushConf, conf, dispatch, widgetID, isPortal) => {
  let runStatus = true
  let runError = ''
  let allowOffline = state.getIn(['project', 'Settings', 'allowOffline'], false)
  const forceShowError = allowOffline && conf.appState
  const params = getParams(state)
  const widgetState = allowOffline && conf.appState ? conf.appState : getState(state)
  const path = []

  const getElemType = (uid) =>
    state.hasIn(['project', 'Settings', 'elements', uid, 'type'])
      ? state.getIn(['project', 'Settings', 'elements', uid, 'type'])
      : state.getIn(['pages', state.get('page'), 'Props', 'elements', uid, 'type'])

  const getElemFieldType = (uid) =>
    state.hasIn(['project', 'Settings', 'elements', uid, 'props', 'control'])
      ? state.getIn(['project', 'Settings', 'elements', uid, 'props', 'control'])
      : state.getIn(['pages', state.get('page'), 'Props', 'elements', uid, 'props', 'control'])

  const getFieldType = (key) => {
    let [__, path] = String(key).split('##')
    const [parent, sectionUID, uid, ...rest] = String(path).split(':')

    if (getElemType(sectionUID) === 'FormField') {
      return getElemFieldType(sectionUID)
    } else if (getElemType(uid) === 'FormField') {
      return getElemFieldType(uid)
    } else {
      return null
    }
  }

  const isDateFieldType = (uid) => ['date', 'time', 'datetime'].includes(getFieldType(uid))

  let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()

  if (sfPushConf) {
    try {
      if (isDisabledSfIntegration('push', conf.list)) {
        return false
      }
    } catch (err) {
      console.error(err)
    }
    if (!conf.runInBackground) {
      let loadingLabels = [],
        isShowLoading = true
      if (conf.value) {
        let listOfPush = state.getIn(['project', 'Settings', 'pushToSalesforce'])
        let values = String(conf.value).split('_')
        listOfPush.map((row) => {
          if (row.get('uid') == conf.value || values.includes(row.get('uid'))) {
            if (row.get('showLoadingMessage')) {
              loadingLabels.push(row.get('loadingMessage', ''))
            }
            // isShowLoading = row.get('showLoadingMessage');
          }
        })
      }
      if (isShowLoading) {
        dispatch({
          type: actionTypes.SHOW_LOADING_WINDOW,
          payload: {
            messages: loadingLabels,
          },
        })
      }
    }
    const reqPostState = {
      state: {},
      list: {},
    }
    if (conf.isBulk) {
      _.each(conf.list, function (sfItem) {
        reqPostState.list[sfItem.value] = {}
      })
    } else {
      reqPostState.list[conf.value] = {}
    }
    let form = new FormData()

    if (conf && conf.elemUID === 'SmartVEvent') {
      try {
        let smartvForm = state.getIn(['state', 'SmartVLogin'], Map()).toJS()
        form.append('SmartVLogin', JSON.stringify(smartvForm))
      } catch (err) {}
    }
    const buildCalendarFiles = []
    let isSendAutoPdfState = false
    let formFieldsPushed = {}
    _.each(sfPushConf.fields, (field) => {
      if (field == 'ft-random-value') {
        reqPostState.state[field] = parseInt(Math.random() * (999999 - 100000))
      } else if (_.startsWith(field, 'PowerTableWidget:')) {
        let localPath = field.split('##')
        localPath.splice(0, 1)
        localPath = localPath.join('##')
        let keyConf = _.concat(localPath.split(':'))
        let elemUID = keyConf[1]
        let columns = state.getIn(
          ['pages', state.get('page'), 'Props', 'elements', elemUID, 'props', 'columns'],
          List()
        )
        let hashCols = {}
        if (columns) {
          columns = columns.toJS()
          _.each(columns, (row) => {
            hashCols[row?.id] = row
          })
        }
        if (conf.index !== undefined && conf.index !== null) {
          if (_.isArray(_.get(widgetState, keyConf))) {
            const keyOrigin = [..._.initial(keyConf), `${_.last(keyConf)}_origin`, conf.index]
            keyConf.push(conf.index)
            reqPostState.state[field] = _.get(widgetState, keyOrigin, _.get(widgetState, keyConf, ''))
          } else {
            const keyOrigin = [..._.initial(keyConf), `${_.last(keyConf)}_origin`]
            reqPostState.state[field] = _.get(widgetState, keyOrigin, _.get(widgetState, keyConf, ''))
          }
        } else {
          let isHaveSelectedItems = false,
            isHavePtField = false
          let isHaveInput = null
          _.each(sfPushConf.fields, (field) => {
            if (String(field).indexOf('PowerTableWidget') > -1 && String(field).indexOf('-selectedItems') == -1) {
              isHavePtField = true
            }
            if (
              (String(field).indexOf('PowerTableWidget') > -1 && String(field).indexOf(':selected') > -1) ||
              (String(field).indexOf('PowerTableWidget') > -1 && String(field).indexOf('-selectedItems') > -1)
            ) {
              isHaveSelectedItems = true
            }
            let colUid = String(field).split(':')
            colUid = _.last(colUid)
            if (colUid && hashCols[colUid]) {
              if (_.get(hashCols[colUid], ['meta', 'role']) == 'input') {
                if (!isHaveInput) {
                  isHaveInput = {}
                }
                isHaveInput[colUid] = field
              }
            }
          })
          if (_.isArray(_.get(widgetState, keyConf)) && isHaveSelectedItems && isHavePtField) {
            let val = _.get(widgetState, keyConf, '')
            if (String(_.last(keyConf)).indexOf('-selectedItems') > -1) {
              val = val.split(',')
            } else {
              val = _.filter(val, (rowVal, index) => {
                return _.get(widgetState, [keyConf[0], keyConf[1], 'selected', index], false)
              })
            }
            reqPostState.state[field] = val
          } else if (_.isArray(_.get(widgetState, keyConf)) && isHaveInput) {
            let val = _.get(widgetState, keyConf, '')
            val = _.filter(val, (rowVal, index) => {
              let isHaveChanges = false
              _.each(isHaveInput, (val, colId) => {
                try {
                  if (state.getIn(['formFieldStatuses', keyConf[0], keyConf[1], colId, index, 'isChanged'])) {
                    let field = [keyConf[1], colId, index].join('_')
                    formFieldsPushed[field] = {
                      path: ['formFieldStatuses', keyConf[0], keyConf[1], colId, index, 'isChanged'],
                    }
                    isHaveChanges = true
                    return false
                  }
                } catch (err) {
                  console.error(err)
                }
              })
              return isHaveChanges
            })
            reqPostState.state[field] = val
          } else {
            reqPostState.state[field] = _.get(widgetState, keyConf, '')
          }
        }
      } else if (_.startsWith(field, 'WidgetTable:') || _.startsWith(field, 'WidgetList:')) {
        let keyConf = _.concat(field.split('##')[1].split(':'))
        if (conf.index !== undefined && conf.index !== null) {
          keyConf.splice(keyConf.length - 1, 0, conf.index)
        }
        reqPostState.state[field] = _.get(widgetState, keyConf, '')
        if (_.isArray(reqPostState.state[field])) {
          reqPostState.state[field] = reqPostState.state[field].join(',')
        }
      } else if (_.startsWith(field, 'tableWidget:')) {
        let keyConf = _.concat(field.split('##')[1].split(':'))
        if (conf.index !== undefined && conf.index !== null) {
          keyConf.splice(keyConf.length - 1, 0, conf.index)
        }
        reqPostState.state[field] = _.get(widgetState, keyConf, '')
      } else if (
        _.startsWith(field, 'view:') ||
        _.startsWith(field, 'formWidget:') ||
        _.startsWith(field, 'ImageChoice:')
      ) {
        let keyConf = _.concat(updateOldValue(field).split('##')[1].split(':')).join('.')
        let keyPath = updateOldValue(field).split('##')[1].split(':')
        let stripID = keyPath[1]
        if (repeatRoot.includes(stripID) && reqPostState.state[stripID + '-totalrows'] == undefined) {
          reqPostState.state[stripID + '-totalrows'] = _.get(widgetState, [keyPath[0], `${stripID}-totalRows`], 0)
        }
        if (repeatRoot.includes(stripID) && _.last(keyPath) === 'ftStripRow') {
          let size = getMappingCount(_.get(widgetState, _.initial(keyPath), ''))
          reqPostState.state[field] = _.times(size, (n) => n + 1)
        } else if (
          repeatRoot.includes(stripID) &&
          (_.endsWith(keyConf, 'ft_value') ||
            _.endsWith(keyConf, 'ft_text') ||
            _.endsWith(keyConf, 'endDate') ||
            _.endsWith(keyConf, 'startDate'))
        ) {
          let key = _.last(keyPath)
          reqPostState.state[field] = _.reduce(
            _.get(widgetState, _.initial(keyPath), ''),
            (r, v) => [...r, _.get(v, key, '')],
            []
          )
        } else {
          let val = _.get(widgetState, keyConf, '')
          try {
            if (!repeatRoot.includes(stripID) && val && _.isArray(val)) {
              val = val.join(',')
            }
          } catch (err) {
            console.error(err)
          }
          reqPostState.state[field] = val
        }
        if (
          String(field).includes(':ft_fileupload_docx') ||
          String(field).includes(':ft_fileupload_sfdt') ||
          String(field).includes(':ft_fileupload_pdf')
        ) {
          let key = 'ftDocGenEditDocx'
          let filePath = field.split('##')[1].split(':')
          let uid = filePath[filePath.length - 2]
          let format = 'docx'
          if (String(field).includes(':ft_fileupload_sfdt')) {
            key = 'ftDocGenEditSfdt'
            format = 'sfdt'
          }
          let fileVal = _.get(window, ['__FT_PROJECT__API__FILES__', key, uid])
          if (fileVal) {
            form.append(field, fileVal, 'Document.' + format)
          }
        } else if (String(field).indexOf('-fileWithMark') > -1) {
          let [pageUID, uid, ...restUIDPath] = field.split('##')[1].split(':')
          let fileVal = _.get(window, [
            '__FT_PROJECT__API__FILES__',
            'files',
            String(uid).replace('-fileWithMark', ''),
            'fileWithMark',
            0,
          ])
          if (fileVal) {
            form.append(field, fileVal, 'interactive_image_markers.png')
          }
        } else if (String(field).indexOf('-file') > -1) {
          let [pageUID, uid, ...restUIDPath] = field.split('##')[1].split(':')
          let fileVal = _.get(window, [
            '__FT_PROJECT__API__FILES__',
            'files',
            String(uid).replace('-file', ''),
            'file',
            0,
          ])
          if (fileVal) {
            form.append(field, fileVal, 'interactive_image.png')
          }
        } else if (String(field).indexOf(':signature_') > -1) {
          let key = field.split('##')[1].split(':')
          let type = key[key.length - 1]
          key.splice(key.length - 1, 1)
          let val = _.get(widgetState, key, '')
          if (val && typeof val == 'object') {
            reqPostState.state[field] = []
            _.each(val, function (row, key) {
              key = parseInt(key)
              if (type == 'signature_base64') {
                reqPostState.state[field][key] = row
              } else if (type == 'signature_html') {
                reqPostState.state[field][key] = `<img src="${row}" />`
              }
            })
          } else {
            if (type == 'signature_base64') {
              reqPostState.state[field] = val
            } else if (type == 'signature_html') {
              reqPostState.state[field] = `<img src="${val}" />`
            }
          }
        } else if (String(field).indexOf(':ft_fileupload') > -1) {
          try {
            if (window.__FT_PROJECT__API__ && typeof window.__FT_PROJECT__API__.getFilesByID == 'function') {
              let key = field.split('##')[1].split(':')
              if (repeatRoot.includes(key[1]) && typeof conf.index !== 'number') {
                let maxItems = _.get(widgetState, [key[0], `${key[1]}-totalRows`], 0)
                reqPostState.state[field] = []
                _.times(maxItems, function (rowIndex) {
                  let files = window.__FT_PROJECT__API__.getFilesByID(key[2], rowIndex)
                  _.each(files, function (file, index) {
                    if (!reqPostState.state[field][rowIndex]) {
                      reqPostState.state[field][rowIndex] = []
                    }
                    reqPostState.state[field][rowIndex].push(file.name)
                    form.append(field + '___' + rowIndex, file)
                  })
                })
              } else {
                let localIndex
                if (typeof conf.index == 'number' && !String(key[2]).includes('ft_fileupload')) {
                  localIndex = conf.index
                  key = key[2]
                } else {
                  key = key[1]
                }
                let files = window.__FT_PROJECT__API__.getFilesByID(key, localIndex)
                _.each(files, function (file, index) {
                  form.append(field + '___' + index, file)
                })
              }
            }
          } catch (err) {
            console.error(err)
          }
        } else if (String(field).indexOf(':value') > -1) {
          if (reqPostState.state[field] && reqPostState.state[field].advanced) {
            reqPostState.state[field] = reqPostState.state[field].advanced
          } else if (reqPostState.state[field] && reqPostState.state[field].value) {
            reqPostState.state[field] = reqPostState.state[field].value
          }
          if (_.isArray(reqPostState.state[field])) {
            reqPostState.state[field] = _.filter(reqPostState.state[field], (v) => v !== '')
          }
          if (_.get(widgetState, [keyPath[0], `${stripID}-totalRows`], 0)) {
            let keyConf = _.concat(field.split('##')[1].split(':'))
            _.times(_.get(widgetState, [keyPath[0], `${stripID}-totalRows`], 0), function (localIndex) {
              if (!reqPostState.state[field] || !_.isArray(reqPostState.state[field])) {
                reqPostState.state[field] = []
              }
              reqPostState.state[field][localIndex] = _.get(widgetState, [...keyConf, localIndex])
              if (reqPostState.state[field][localIndex] === undefined) {
                reqPostState.state[field][localIndex] = ''
              }
            })
          }
        }
        if (conf.widgetPath.length && conf.widgetPath[0] !== undefined && _.startsWith(field, 'formWidget:')) {
          let formKeyConf = _.concat(field.split('##')[1].split(':'))
          formKeyConf.splice(formKeyConf.length - 1, 0, ...conf.widgetPath)
          reqPostState.state[field] = _.get(widgetState, formKeyConf, '')
        } else if (conf.widgetPath.length && conf.widgetPath[0] !== undefined) {
          if (_.isArray(reqPostState.state[field])) {
            reqPostState.state[field] = _.get(reqPostState.state[field], conf.widgetPath, '')
          } else if (
            _.isObject(reqPostState.state[field]) &&
            _.get(reqPostState.state, [field, String(conf.widgetPath[0])]) !== undefined
          ) {
            reqPostState.state[field] = _.get(reqPostState.state[field], String(conf.widgetPath), '')
          }
        }
        let fieldType = getFieldType(field)
        if (fieldType == 'radio' && repeatRoot.includes(stripID)) {
          keyConf = String(keyConf).split('.')
          let propKey = keyConf.splice(-1)
          let list = _.get(widgetState, keyConf, [])
          if (list) {
            let resultValue = []
            _.each(list, function (val, index) {
              if (!Number.isNaN(parseInt(index, 10))) {
                if (conf.index !== undefined && conf.index !== null) {
                  if (parseInt(index) == conf.index) {
                    resultValue.push(_.get(val, [propKey], ''))
                  }
                } else {
                  resultValue.push(_.get(val, [propKey], ''))
                }
              }
            })
            if (conf.index !== undefined && conf.index !== null) {
              reqPostState.state[field] = resultValue.join(',')
            } else {
              reqPostState.state[field] = resultValue
            }
          }
        } else if (['date', 'time', 'datetime'].includes(fieldType)) {
          reqPostState.state[field] = Boolean(reqPostState.state[field]) ? reqPostState.state[field] : null
        }
      } else if (_.startsWith(field, 'pageParam##')) {
        const keyConf = _.concat(field.split('##')[1].split(':')).join('.')
        reqPostState.state[field] = _.get(widgetState, keyConf, '')
      } else if (_.startsWith(field, 'docGen##')) {
        let actionID = _.last(String(field).split('##'))
        let isSfdtResult = false
        if (String(actionID).includes(':')) {
          actionID = String(actionID).split(':')
          isSfdtResult = actionID[0] === 'sfdt'
          actionID = actionID[1]
        }
        let action = state.getIn(['project', 'Settings', 'store', 'public', actionID])
        if (action && action.get('type') === 'AUTO_PDF') {
          isSendAutoPdfState = true
        }
        let keys = _.keys(conf?.options)
        let keyValue = null
        if (isSfdtResult) {
          _.set(conf, ['options', 'isSfdtResult'], isSfdtResult)
        }
        if (keys.includes('ftDocGenEditDocx')) {
          keyValue = _.get(conf, ['options', 'ftDocGenEditDocx'])
        } else if (keys.includes('ftDocGenEditPdf')) {
          keyValue = _.get(conf, ['options', 'ftDocGenEditPdf'])
        }
        if (keyValue) {
          reqPostState.state[field] = keyValue
        } else if (action) {
          let recordID = getValueByField(action.getIn(['fields', 'recordID'], Map()), params, widgetState, conf.index)
          if (recordID) {
            reqPostState.state[field] = recordID
          }
        }
        const currState = widgetState
        const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
        state.getIn(['project', 'Settings', 'store', 'public', actionID, 'templateFields'], List()).map((v) => {
          const group = v.get('group')
          if (group === 'param') {
            reqPostState.state[v.get('value')] = state.getIn(
              ['params', String(v.get('value').replace('param', ''))],
              ''
            )
          } else if (group === 'pageParam') {
            const [pageUID, paramID] = String(v.get('value')).split(':')
            reqPostState.state[v.get('value')] = state.getIn(['state', pageUID, paramID], '')
          } else {
            const value = String(v.get('value'))
            if (_.startsWith(group, 'formWidget:') || _.startsWith(group, 'listWidget:')) {
              reqPostState.state[v.get('value')] = toPlainValue(_.get(currState, value.replace(/:/g, '.'), ''))
            } else if (_.startsWith(group, 'form:')) {
              reqPostState.state[v.get('value')] = toPlainValue(
                _.get(currState, `${_.get(window.__FT_APP_STATE__, 'widget._id')}.${value}`, null)
              )
            } else if (group === 'smartv') {
              reqPostState.state[v.get('value')] = isUserSignIn ? 'true' : ''
            } else if (group === 'strip') {
              let path = updateOldValue(value).split(':')
              if (repeatRoot.includes(path[1]) && _.size(path) === 2) {
                let stripState = _.get(currState, path, '')
                try {
                  _.each(stripState, (value, elID) => {
                    const elem = getElementFromPath([...path.slice(0, 2), elID], state)
                    if (
                      Map.isMap(elem) &&
                      elem.get('type') === 'FormField' &&
                      ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))
                    ) {
                      if (_.isArray(value)) {
                        _.each(value, (val, index) => {
                          let format = getFormDateFormat(
                            elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                            elem.getIn(['props', 'control'])
                          )
                          if (_.get(hashFields, [`${path.join(':')}:${elID}`, 'control'])) {
                            if (elem.getIn(['props', 'control']) === 'time') {
                              format = 'HH:mm'
                            } else if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                              format = 'YYYY-MM-DDTHH:mm'
                            } else if (elem.getIn(['props', 'control']) === 'date') {
                              format = 'YYYY-MM-DD'
                            }
                          }
                          let date = moment(val)
                          if (date.format() !== 'Invalid date') {
                            _.set(stripState, [elID, index], date.format(format))
                          } else {
                            _.set(stripState, [elID, index], toPlainValue(val))
                          }
                        })
                      } else {
                        let val = value
                        let format = getFormDateFormat(
                          elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                          elem.getIn(['props', 'control'])
                        )
                        let date = moment(val)
                        if (date.format() !== 'Invalid date') {
                          _.set(stripState, [elID], date.format(format))
                        } else {
                          _.set(stripState, [elID], toPlainValue(val))
                        }
                      }
                    }
                  })
                } catch (error) {
                  console.error(error)
                }

                reqPostState.state[`${path[0]}:${path[1]}`] = stripState
              }
            } else {
              let path = updateOldValue(value).split(':')
              let elem = getElementFromPath(path, state)
              if (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === 'ImageChoice') {
                if (_.last(path) === 'ftListLabel') {
                  reqPostState.state[v.get('value')] = toPlainValue(
                    _.get(currState, [..._.initial(path), 'ftListValue'], '')
                  )
                  return true
                }
                reqPostState.state[v.get('value')] = toPlainValue(_.get(currState, [...path, 'ftListValue'], ''))
                return true
              } else if (
                elem.get('type') === 'FormField' &&
                ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))
              ) {
                let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                let format = getFormDateFormat(
                  elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                  elem.getIn(['props', 'control'])
                )
                let date = moment(val)
                if (date.format() !== 'Invalid date') {
                  if (elem.getIn(['props', 'control']) === 'time') {
                    format = 'HH:mm'
                  } else if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                    format = 'YYYY-MM-DDTHH:mm'
                  } else if (elem.getIn(['props', 'control']) === 'date') {
                    format = 'YYYY-MM-DD'
                  }
                  reqPostState.state[v.get('value')] = date.format(format)
                  return true
                } else {
                  reqPostState.state[v.get('value')] = toPlainValue(
                    _.get(currState, updateOldValue(value).replace(/:/g, '.'), '')
                  )
                  return true
                }
              }
              let valuePath = updateOldValue(value).split(':')
              if (repeatRoot.includes(valuePath[1])) {
                if (_.size(valuePath) === 2) {
                  return false
                }
                reqPostState.state[`${valuePath[0]}:${valuePath[1]}`] = _.get(
                  currState,
                  [valuePath[0], valuePath[1]],
                  ''
                )
                return
              }
              reqPostState.state[v.get('value')] = toPlainValue(
                _.get(currState, updateOldValue(value).replace(/:/g, '.'), '')
              )
            }
          }
        })
      } else if (_.startsWith(field, 'ecom##')) {
        let parsedPath = _.last(String(field).split('##')).split(/:/g)
        if (parsedPath[1] == 'cartData') {
          let cartList = _.get(widgetState, ['eCommerce', 'e_cart'], [])
          let prop = parsedPath.slice(2)
          let val = []
          _.each(cartList, function (row) {
            val.push(_.get(row, prop))
            if (row && row.addons) {
              _.each(row.addons, function (addon) {
                val.push(_.get(addon, prop, ''))
              })
            }
          })
          reqPostState.state[field] = val
        } else {
          const keyConf = [...path, ...parsedPath]
          reqPostState.state[field] = _.get(widgetState, keyConf, '')
        }
      } else if (_.startsWith(field, 'param##')) {
        let paramId = _.last(String(field).split('##'))
        const keyConf = [...path, paramId]
        reqPostState.state[field] = _.get(params, keyConf, '')
        if (reqPostState.state[field]) {
          reqPostState.state[`prot_${paramId}`] = _.get(params, [`prot_${paramId}`], '')
        }
      } else if (_.startsWith(field, 'params##')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        reqPostState.state[field] = _.get(params, keyConf, '')
      } else if (_.startsWith(field, 'smartvReg')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        reqPostState.state[field] = _.get(widgetState, keyConf, '')
      } else if (_.startsWith(field, 'SmartVProfile')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        reqPostState.state[field] = _.get(widgetState, keyConf, '')
      } else if (_.startsWith(field, 'smartv')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        reqPostState.state[field] = _.get(getPreviewDynamicData(), ['svParams', keyConf], '')
      } else if (_.startsWith(field, 'calendar##')) {
        let [__, calID] = String(field).split('##')
        const getCal = async (calID) => {
          let file = await getCalendarFileContent(calID, state)
          let blob = new Blob([file], { type: 'text/calendar;charset=utf-8;' })
          reqPostState.state[field] = file
          form.append(field, blob, 'calendar.ics')
        }
        buildCalendarFiles.push(getCal(calID))
      }
    })
    if (buildCalendarFiles.length > 0) {
      await Promise.all(buildCalendarFiles)
    }
    if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
      console.log('custom action sf push >>> ', Object.keys(reqPostState.list))
    }
    let gCode
    if (conf.isVerifyCaptcha) {
      gCode = await window.__FT_PROJECT__API__.ftGetCaptchaToken()
      if (!gCode) {
        dispatch({
          type: actionTypes.PROCESS_SF_PUSH,
          payload: {
            isShowLoading: false,
            loadingMessages: {},
          },
        })

        dispatch({
          type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
          payload: {
            list: reqPostState.list,
            isSFPush: true,
            params: {},
          },
        })
        return false
      } else {
        form.append('gCode', gCode)
      }
    }

    form.append('elemUID', conf.elemUID)
    form.append('ruleUID', conf.ruleUID)

    form.append('actionRuleId', conf.actionRuleId)
    form.append('nodeId', conf.nodeId)

    let isBackground = false
    if (conf.runInBackground && !conf.recTarget) {
      try {
        isBackground = true
        _.each(conf.list, (row) => {
          if (row && row.recTarget) {
            isBackground = false
          }
        })
        if (isBackground) {
          form.append('isBackground', 1)
        }
      } catch (err) {
        console.error(err)
      }
    }

    form.append('state', JSON.stringify(reqPostState.state))
    form.append('list', JSON.stringify(reqPostState.list))
    if (isSendAutoPdfState) {
      form.append('autoPdfState', JSON.stringify(collectAutoPDFState(state)))
    }
    _.each(conf?.options || {}, (value, key) => {
      if (['ftDocGenEditDocx', 'ftDocGenEditPdf'].includes(key)) {
        if (_.get(conf, ['options', 'isSfdtResult'])) {
          form.append(value, _.get(window, ['__FT_PROJECT__API__FILES__', 'ftDocGenEditSfdt', value]), 'Document.sfdt')
        } else {
          form.append(value, _.get(window, ['__FT_PROJECT__API__FILES__', key, value]))
        }
      } else {
        form.append(key, JSON.stringify(value))
      }
    })
    try {
      const recursiveProcessPush = async (attempt) => {
        if (attempt >= 3) {
          return {
            status: 200,
            data: {
              status: false,
              canceled: {
                [conf.value]: true,
              },
            },
          }
        }
        try {
          let result = await axios.post('/webprojects/push/sfmapping', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          return result
        } catch (err) {
          console.log('err >>> ', err)
          let errorMessage = `You are offline, trying again in 2 seconds...`
          try {
            if (String(err).indexOf('413') > -1) {
              dispatch({
                type: actionTypes.NOTIFY_ERROR,
                payload: {
                  key: uuid(),
                  message: 'Request Entity Too Large',
                },
              })
              return {
                data: {
                  status: false,
                  canceled: {
                    [conf.value]: true,
                  },
                },
              }
            } else if (navigator.onLine) {
              errorMessage = `Bad response, trying again in 2 seconds...`
            }
          } catch (e) {}
          if (!allowOffline) {
            dispatch({
              type: actionTypes.NOTIFY_ERROR,
              payload: {
                key: uuid(),
                message: errorMessage,
              },
            })
          }
          await new Promise((resolve) => {
            setTimeout(resolve, 2 * 1000)
          })

          return recursiveProcessPush(attempt + 1)
        }
      }
      const { status, data } = await recursiveProcessPush(0)
      if (!data.status) {
        formFieldsPushed = {}
        if (data.error == 'captcha_denied') {
          dispatch({
            type: actionTypes.PROCESS_SF_PUSH,
            payload: {
              isShowLoading: false,
              loadingMessages: {},
              captchaElem: conf.elemUID,
            },
          })
        } else if (data.error == 'session_expired') {
          if (state.get('page') != 'signin') {
            window.__FT_PROJECT__API__.navigateToSignInPage()
          }
          dispatch({
            type: actionTypes.PROCESS_SF_PUSH,
            payload: {
              isShowLoading: false,
              loadingMessages: {},
            },
          })
          return false
        } else {
          runStatus = false
          runError = 'Network error'
        }
      }

      if (data.globalOutFields) {
        dispatch({
          type: actionTypes.PROCESS_SF_CHILD_MAPPING,
          payload: {
            path: [],
            data: {
              status: 'success',
              data: data.globalOutFields,
            },
          },
        })
      }
      if (data.outFields) {
        dispatch({
          type: actionTypes.PROCESS_SF_CHILD_MAPPING,
          payload: {
            path: [],
            data: {
              status: 'success',
              data: data.outFields,
            },
          },
        })
      }
      if (data.errorsBack) {
        let errorData = {}
        _.each(data.errorsBack, (row, key) => {
          if (row && row.error) {
            errorData[key] = row.error
          }
        })
        dispatch({
          type: actionTypes.PROCESS_SF_CHILD_MAPPING,
          payload: {
            path: [],
            data: {
              status: 'success',
              data: errorData,
            },
          },
        })
      }

      let isShowLoading = false
      let loadingMessages = {}
      if (data && data.messages && Object.keys(data.messages).length) {
        formFieldsPushed = {}
        isShowLoading = true
        loadingMessages.type = 'error'
        loadingMessages.isAlloClose = true
        loadingMessages.list = []
        _.each(data.messages, (msg) => {
          loadingMessages.list.push(msg)
        })
        runError = loadingMessages.list.join('\n')
      } else if (data.error && forceShowError) {
        formFieldsPushed = {}
        isShowLoading = true
        loadingMessages.type = 'error'
        loadingMessages.isAlloClose = true
        loadingMessages.list = []
        if (data.error && data.error.name) {
          runError = data.error.name
          loadingMessages.list.push({
            error: data.error.name,
          })
        } else if (typeof data.error === 'string') {
          runError = data.error
          loadingMessages.list.push({
            error: data.error,
          })
        }
      } else if (data.error) {
        formFieldsPushed = {}
        if (data.error && data.error.name) {
          runError = data.error.name
        } else if (typeof data.error === 'string') {
          runError = data.error
        }
      }
      if (_.size(data?.canceled) > 0 && _.size(data?.data) === 0) {
        formFieldsPushed = {}
        dispatch(processSFItemCancel(conf.processUID, conf.nodeId))
      }

      let callbackParams = {
        paramPath: [],
        paramID: conf.recTarget,
        isShowLoading,
        loadingMessages,
        elemUID: conf.elemUID,
        response: data,
        formFieldsPushed,
      }

      if (conf.isBulk) {
        let resultRecords = []
        _.each(conf.list, function (sfItem) {
          if (_.get(data, `data.${sfItem.value}`) !== undefined) {
            resultRecords.push({
              recID: _.get(data, `data.${sfItem.value}`, null),
              paramID: sfItem.recTarget,
            })
          }
        })
        callbackParams.resultRecords = resultRecords
      } else {
        if (_.get(data, `data.${conf.value}`) !== undefined) {
          callbackParams.recID = _.get(data, `data.${conf.value}`, '')
          callbackParams.paramID = conf.recTarget
        }
      }

      dispatch({
        type: actionTypes.PROCESS_SF_PUSH,
        payload: callbackParams,
      })
      dispatch({
        type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
        payload: {
          list: reqPostState.list,
          isSFPush: true,
          params: data,
        },
      })
    } catch (err) {
      runStatus = false
      console.error('processWidgetCustomSFPushItem err >>>> ', err)
      runError = 'Network error'
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message: `An error occurred, try again later.`,
        },
      })

      dispatch({
        type: actionTypes.PROCESS_SF_PUSH,
        payload: {
          paramPath: [],
          isShowLoading: false,
        },
      })
    }
  }
  return {
    status: runStatus,
    error: runError,
  }
}

export const processRunSFPost = (item, index) => async (dispatch, getState) => {
  let state = getState()
  if (item.getIn([0, 'runStatus'], '') !== 'Running') {
    const runID = uuid()
    item = item.map((val) => val.set('runIndex', index).set('runID', runID))
    let list = state.getIn(['query', 'list'], List())
    state = state.setIn(['query', 'list'], list.concat(item))

    state = state
      .setIn(['connMode', 'list', index, 0, 'runStatus'], 'Running')
      .setIn(['connMode', 'list', index, 0, 'runID'], runID)

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
}

export const setFormErrorMessage = (form, messages) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['formMessages', form, 'messages'], fromJS(messages)),
    },
  })
}

export const setProjectPreviewStore = (store) => (dispatch, getState) => {
  let state = getState()
  let pageUID
  state.getIn(['project', 'Pages'], List()).map((page) => {
    if (page.get('_id') == state.get('page')) {
      pageUID = page.get('uid')
    }
  })
  store.map((val, key) => {
    if (key == 'pages' || key == 'rules') {
      if (Map.isMap(val)) {
        val.map((page, pageID) => {
          if (pageUID != pageID) {
            state = state.setIn([key, pageID], page)
          }
        })
      }
    } else {
      if (val) {
        state = state.set(key, val)
      }
    }
  })
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const buildBulkdSFPush = (conf, sfPush) => {
  let fields = []
  let hashSFPush = {}
  _.each(sfPush, function (sfItem) {
    if (sfItem && sfItem.uid) {
      hashSFPush[sfItem.uid] = sfItem
    }
  })
  _.each(conf.list, function (sfItem) {
    if (sfItem && sfItem.value && hashSFPush[sfItem.value]) {
      fields = fields.concat(hashSFPush[sfItem.value].fields)
    }
  })
  fields = _.compact(_.uniq(fields))
  // if (fields.length) {
  return {
    fields,
  }
  // }
  return false
}

export const projectSetFormState = (path, formState) => (dispatch) =>
  dispatch({
    type: actionTypes.PROJECT_FORM_RESET,
    payload: {
      path,
      formState,
    },
  })

export const clearFormMessages = (uid) => (dispatch) =>
  dispatch({
    type: actionTypes.FORM_CLEAR_MESSAGES,
    payload: {
      uid,
    },
  })

export const clearPowerTableSubData = (sfItemId) => (dispatch, getState) => {
  try {
    let state = getState()
    let sfItem = state.getIn(['project', 'Settings', 'sfMapping', sfItemId])
    if (!sfItem) {
      return false
    }
    let fields = sfItem.get('gridFields')
    if (!fields) {
      return false
    }
    fields.map((field) => {
      if (field) {
        let [group, fieldPath] = String(field).split('#-#')
        if (!fieldPath) {
          return false
        }
        let path = fieldPath.split(':')
        if (fieldPath.includes('-totalRows')) {
          state = state.setIn(['state', ...path], 0)
        } else if (path.length > 2) {
          state = state.setIn(['state', ..._.initial(path)], Map())
          state = state.setIn(['state', path[0], `bulk-${path[1]}`], Map())
          state = state.setIn(['state', path[0], `${path[1]}-PowerTableBatchChanged`], false)
        }
      }
    })
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  } catch (err) {
    console.error(err)
  }
}

export const processTableAction = (actions, uid, index, fieldType, rowValue, inClientY) => (dispatch) => {
  let clientY = inClientY
  try {
    if (window && window.event && window.event.clientY) {
      clientY = window.event.clientY
      window.ftLastClientY = clientY
    }
  } catch (err) {}
  dispatch({
    type: actionTypes.PROCESS_WB_TABLE_ACTION,
    payload: {
      uid,
      actions,
      index,
      fieldType,
      rowValue,
      options: {
        clientY: clientY,
      },
    },
  })
}

export const portalUpdateWidgetsList = (widgets) => (dispatch) =>
  dispatch({
    type: actionTypes.PORTAL_UPDATE_WIDGETS_DATA,
    payload: {
      widgets: widgets,
    },
  })

export const widgetSetFormHiddenData = () => (dispatch) => dispatch({ type: actionTypes.WIDGET_SET_FORM_HIDDEN })

export const portalSetFormHiddenData = () => (dispatch) => dispatch({ type: actionTypes.PORTAL_SET_FORM_HIDDEN })

export const wbViewChangeLayoutMode = (mode, prevMode) => (dispatch) =>
  dispatch({
    type: actionTypes.REFRESH_PREVIEW_MODE,
    payload: { mode, prevMode },
  })

export const changeShowModalState = (modal, state) => (dispatch) =>
  dispatch({
    type: actionTypes.PROJECT_CHANGE_MODAL_STATE,
    payload: {
      modal,
      state,
    },
  })

export const projectChangeUIWidgetElProps = (props) => (dispatch) =>
  dispatch({
    type: actionTypes.PROJECT_CHANGE_UI_ADD_WIDGET,
    payload: { props },
  })

export const setParamsToLocalStorage = () => (dispatch, getState) => {
  try {
    const state = getState()

    let params = state.getIn(['params'], Map()).toJS()
    let projectID = state.getIn(['project', '_id'])
    let pageJob = state.getIn(['pageJob'], Map()).toJS()

    ftSetLocalStorage('local_params_' + projectID, JSON.stringify(params))

    ftSetLocalStorage('local_pagejobs_' + projectID, JSON.stringify(pageJob))
  } catch (err) {
    console.error(err)
  }
}

export const processConnBatchItemBatch = () => (dispatch, getState) => {
  let state = getState()
  const oldBatch = state.getIn(['connMode', 'batch'], List())

  let item = oldBatch.get(0)
  // console.log(toJS(item))
  state = state.setIn(['connMode', 'batch'], oldBatch.delete(0))

  let list = state.getIn(['query', 'list'], List())
  state = state.setIn(['query', 'list'], list.concat(item))

  if (state.getIn(['connMode', 'batch'], List()).size === 0) {
    state = state.setIn(['connMode', 'batchStatus'], false)
  }
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const processRunConnBatch = () => (dispatch, getState) => {
  let state = getState()
  let list = state.getIn(['connMode', 'list'], List())
  let selected = state.getIn(['connMode', 'selected'], Map())
  let skip = list.filter((item, index) => !selected.get(index, false))
  let batchRun = list.filter((item, index) => selected.get(index, false))

  const oldBatch = state.getIn(['connMode', 'batch'], List())

  state = state
    .setIn(['connMode', 'list'], skip)
    .setIn(['connMode', 'batchStatus'], true)
    .setIn(['connMode', 'selected'], Map())
    .setIn(['connMode', 'batch'], oldBatch.concat(batchRun))

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}
export const setConnStatus = (status) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['connMode', 'status'], status),
    },
  })
}

export const addItemToOfflineList = (item) => (dispatch, getAppState) => {
  let state = getAppState()
  let list = state.getIn(['connMode', 'list'], List())
  let jsonItem = JSON.stringify(toJS(item))
  let isNew = !list.find((listItem) => {
    return JSON.stringify(toJS(listItem)) === jsonItem
  })
  if (isNew) {
    state = state.setIn(['connMode', 'list'], list.insert(0, fromJS(item)))
  }
  dispatch(setConnStatus(false))
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
  updateOfflineStorage(state)
}

const updateOfflineStorage = (state) => {
  let appState = getState(state)
  let params = getParams(state)
  let offlineList = state.getIn(['connMode'], Map())
  let projectID = state.getIn(['project', '_id'], Map())
  let rules = state.getIn(['rules'], Map())
  let publicGuid = getPreviewDynamicData().publicGuid
  if (offlineList.get('list', List()).size > 0) {
    let offlineState = {
      state: appState,
      params,
      offlineList: offlineList.toJS(),
      projectID,
      rules: rules.toJS(),
      publicGuid,
    }
    ftSetOfflineValue(`offline_${projectID}`, compressToUTF16(JSON.stringify(offlineState)))
  } else {
    ftDeleteOfflineValue(`offline_${projectID}`)
  }
}

export const setProcessingQueryStatus = (index) => (dispatch, getState) => {
  let state = getState()
  let query = state.getIn(['query', 'list'], List())
  if (query.get(index)) {
    query = query.setIn([index, 'isProcessing'], true)
    state = state.setIn(['query', 'list'], query)

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
}

export const setConnSelection = (index, status) => (dispatch, getState) => {
  let state = getState()
  state = state.setIn(['connMode', 'selected', index], status)
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const processEditRequestData = (item, index) => (dispatch, getState) => {
  let state = getState()
  let id = uuid()
  let appState = item.getIn([0, 'appState'], Map())
  state = state.setIn(['state'], state.get('state', Map()).mergeDeep(appState))

  state = state.setIn(
    ['connMode', 'list', index],
    state.getIn(['connMode', 'list', index], List()).map((val) => val.set('runID', id))
  )

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })

  setTimeout(() => {
    dispatch(removeItemToOfflineList(id))
  }, 1000)
}

export const updateItemInOfflineListError = (uid, error) => (dispatch, getState) => {
  let state = getState()
  let index = state.getIn(['connMode', 'list'], List()).findIndex((val) => val.getIn([0, 'runID']) === uid)
  if (index !== -1) {
    state = state.setIn(
      ['connMode', 'list', index],
      state.getIn(['connMode', 'list', index], List()).map((val) => val.set('runStatus', error))
    )

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
}

export const updateItemInOfflineListComplete = (uid) => (dispatch, getState) => {
  let state = getState()
  let index = state.getIn(['connMode', 'list'], List()).findIndex((val) => val.getIn([0, 'runID']) === uid)
  if (index !== -1) {
    state = state.setIn(
      ['connMode', 'list', index],
      state.getIn(['connMode', 'list', index], List()).map((val) => val.set('runStatus', 'Complete'))
    )

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
}

export const removeItemToOfflineList = (uid) => (dispatch, getState) => {
  let state = getState()
  let index = state.getIn(['connMode', 'list'], List()).findIndex((val) => val.getIn([0, 'runID']) === uid)
  if (index !== -1) {
    state = state.deleteIn(['connMode', 'list', index]).deleteIn(['connMode', 'selected', index])

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
    updateOfflineStorage(state)
  }
}

export const setOfflineSession =
  (data, isApply = true) =>
  (dispatch, getState) => {
    let state = getState()

    let appState = fromJS(_.get(data, 'state', {}))
    let params = fromJS(_.get(data, 'params', {}))
    let offlineList = fromJS(_.get(data, 'offlineList', {}))
    let rules = fromJS(_.get(data, 'rules', {}))

    if (isApply) {
      state = state
        .setIn(['rules'], rules)
        .setIn(['connMode'], offlineList)
        .setIn(['params'], params)
        .setIn(['state'], appState)
    } else {
      state = state.setIn(['connMode'], offlineList)
    }

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }
